export default __webpack_public_path__ + "static/media/image-gallery-cone.fb0906a7.jpg";